import { useApiFetcherSWR } from "hooks/SwrCustom";

const API_ENDPOINT = {


    TRAVEL_COST_LIST: {
        url: 'travelcost-list',
        method: "get",
    },

    DOWNLOAD_DOCUMENT: (id, type) => ({
        url: `document/${id}/${type}/travelcost`,
        method: "get",
    }),
    // ================= Calculations Panel =================

    COMMUNITY_LIST: {
        url: "travelcost/community-list",
        method: "get",
    },

    TRAVEL_COST_DATA: (id) => ({
        url: `travelcost/travelcost-data/${id}`,
        method: "get",
    }),

    SUBSTITUTOR_LIST: (id) => ({
        url: `travelcost/substitutor-list/${id}`,
        method: "post",
    }),

    SUBSTITUTOR_SHIFTS: {
        url: "travelcost/substitutor-shifts-list",
        method: "post",
    },

    SAVE_TRAVEL_COST: {
        url: "travelcost/save-calculated-travelcost",
        method: "post",
    },

    TRAVEL_COST_SUMMARY: {
        url: "travelcost/summary",
        method: "post",
    },

    // ================= Calculation Panel (Distance) =================

    DISTANCE_LIST: {
        url: "verzoeken/scherm/distance-list",
        method: "get",
    },

    VALIDATE_ADDRESS: {
        url: "address/validate",
        method: "post",
    },

    SAVE_ADDRESS: {
        url: "address/save",
        method: "post",
    },

    CALCULATE_DISTANCE: {
        url: "travelcost/calculate-distance",
        method: "post",
    },

    UPDATE_DISTANCE: {
        url: "verzoeken/scherm/update-distance",
        method: "post",
    },

};



export const useTravelCostList = (selectedCommunity) =>
    useApiFetcherSWR({
        url: `${API_ENDPOINT.TRAVEL_COST_LIST.url}/${Number(selectedCommunity)}`,
        method: "get",
    });

export const useDownloadTravelCostDocument = (id, type) => {
    return useApiFetcherSWR(
        id && type ? API_ENDPOINT.DOWNLOAD_DOCUMENT(id, type) : null
    );
};

// ================= Calculations =================

export const useCommunityList = () =>
    useApiFetcherSWR(API_ENDPOINT.COMMUNITY_LIST);



export const useTravelCostData = (id) =>
    useApiFetcherSWR(
        id ? API_ENDPOINT.TRAVEL_COST_DATA(id) : null
    );

export const useSubstitutorList = (id) =>
    useApiFetcherSWR(
        id
            ? API_ENDPOINT.SUBSTITUTOR_LIST(id)
            : { url: null, method: "get" }
    );

export const useSubstitutorShifts = () =>
    useApiFetcherSWR(API_ENDPOINT.SUBSTITUTOR_SHIFTS);

export const useSaveTravelCost = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_TRAVEL_COST);

export const useTravelCostSummary = () =>
    useApiFetcherSWR(API_ENDPOINT.TRAVEL_COST_SUMMARY);


export const useDistanceList = (id, params = {}) => {
    const queryString = new URLSearchParams(params).toString();

    return useApiFetcherSWR({
        url: `verzoeken/scherm/distance-list/${id}?${queryString}`,
        method: "get",
    });
};

export const useValidateAddress = () =>
    useApiFetcherSWR(API_ENDPOINT.VALIDATE_ADDRESS);

export const useSaveAddress = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_ADDRESS);

export const useCalculateDistance = () =>
    useApiFetcherSWR(API_ENDPOINT.CALCULATE_DISTANCE);

export const useUpdateDistance = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_DISTANCE);

export default API_ENDPOINT;